export interface TeamMember {
  id: number;
  name: string;
  phone: string;
  specialty: string;
  status: "available" | "busy" | "vacation";
  tasks: number;
  rating: string;
  initials: string;
  avatar: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "أحمد محمد",
    phone: "0551234567",
    specialty: "غسيل سيارات",
    status: "available",
    tasks: 23,
    rating: "4.7",
    initials: "أ م",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20friendly%20Saudi%20Arabian%20man%20in%20his%20early%20thirties%20wearing%20a%20dark%20teal%20work%20polo%20shirt%2C%20short%20black%20hair%2C%20warm%20genuine%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20approachable%20and%20trustworthy%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-ahmed&orientation=squarish",
  },
  {
    id: 2,
    name: "سارة العلي",
    phone: "0557654321",
    specialty: "تنظيف",
    status: "busy",
    tasks: 18,
    rating: "4.9",
    initials: "س ع",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20friendly%20Saudi%20Arabian%20woman%20in%20her%20late%20twenties%20wearing%20an%20elegant%20teal%20hijab%20and%20a%20light%20uniform%2C%20warm%20kind%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20trustworthy%20and%20caring%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-sara&orientation=squarish",
  },
  {
    id: 3,
    name: "خالد المطيري",
    phone: "0559876543",
    specialty: "الكل",
    status: "available",
    tasks: 31,
    rating: "4.6",
    initials: "خ م",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20Saudi%20Arabian%20man%20in%20his%20early%20forties%20wearing%20a%20dark%20teal%20work%20shirt%2C%20short%20dark%20hair%20with%20a%20trimmed%20beard%2C%20friendly%20assured%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20experienced%20and%20reliable%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-khaled&orientation=squarish",
  },
  {
    id: 4,
    name: "نورة الشهري",
    phone: "0553332211",
    specialty: "تنظيف",
    status: "available",
    tasks: 15,
    rating: "4.8",
    initials: "ن ش",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20cheerful%20Saudi%20Arabian%20woman%20in%20her%20mid%20twenties%20wearing%20a%20soft%20teal%20hijab%20and%20a%20clean%20uniform%2C%20bright%20friendly%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20warm%20and%20welcoming%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-noura&orientation=squarish",
  },
  {
    id: 5,
    name: "عبدالله السالم",
    phone: "0554443322",
    specialty: "غسيل سيارات",
    status: "vacation",
    tasks: 27,
    rating: "4.5",
    initials: "ع س",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20calm%20Saudi%20Arabian%20man%20in%20his%20mid%20thirties%20wearing%20a%20dark%20teal%20work%20polo%20shirt%2C%20short%20black%20hair%20and%20a%20neat%20beard%2C%20relaxed%20confident%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20calm%20and%20steady%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-abdullah&orientation=squarish",
  },
  {
    id: 6,
    name: "ريم القحطاني",
    phone: "0555556677",
    specialty: "الكل",
    status: "busy",
    tasks: 22,
    rating: "4.9",
    initials: "ر ق",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20lively%20Saudi%20Arabian%20woman%20in%20her%20late%20twenties%20wearing%20a%20stylish%20teal%20hijab%20and%20a%20clean%20uniform%2C%20energetic%20friendly%20smile%2C%20clean%20modern%20studio%20background%20in%20soft%20light%20teal%20color%2C%20natural%20diffused%20lighting%2C%20sharp%20focus%20on%20face%2C%20high%20quality%20professional%20photography%2C%20positive%20and%20cheerful%20expression%2C%20editorial%20corporate%20portrait%20style&width=400&height=400&seq=team-member-reem&orientation=squarish",
  },
];

export interface Driver {
  id: number;
  name: string;
  order: string;
  status: string;
  rating: string;
}

export const drivers: Driver[] = [
  { id: 1, name: "أحمد الفيومي", order: "#GH-2849", status: "تم التسليم", rating: "4.8" },
  { id: 2, name: "محمد السبيعي", order: "#GH-2855", status: "في الطريق", rating: "4.6" },
  { id: 3, name: "فهد العتيبي", order: "#GH-2858", status: "قيد الاستلام", rating: "4.7" },
];

export const specialties = ["غسيل سيارات", "تنظيف", "الكل"];